/* eslint-disable react-hooks/exhaustive-deps */
import { Typography, Button } from "@material-ui/core";
import { useState, useEffect } from "react";
import styled from "styled-components";
import moment from "moment";
import { Skeleton } from "@material-ui/lab";
import { usePagination } from "../../hooks";
import { getContent } from "../../services";
import { Image, Modal } from "../../components";

const StyledWrapKegiatan = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 2rem;
  row-gap: 4rem;
  @media screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 750px) {
    grid-template-columns: 1fr;
  }
`;

const SrtyledWrapCard = styled.div`
  text-align: center;
`;

type ItemProps = {
  onClick: () => void;
  isId: boolean;
  data: {
    title_id: string;
    title_en: string;
    subtitle: string;
    image: string;
    content: string;
  };
};

const ItemKegiatan = ({ onClick, data, isId }: ItemProps) => (
  <SrtyledWrapCard onClick={onClick}>
    <Image
      redLine={true}
      height={230}
      src={`${process.env.REACT_APP_URL}/images/${data.image}`}
    />
    <Typography variant="h6" color="textPrimary" style={{ marginTop: "1rem" }}>
      {isId ? data.title_id : data.title_en}
    </Typography>
  </SrtyledWrapCard>
);

const Kegiatan = ({ isId }: any) => {
  const [openModal, setOpenModal] = useState(false);
  const [kegiatanState, setKegiatanState] = useState([]);
  const [dataModal, setDataModal] = useState({
    title: "",
    subtitle: "",
    photo: "",
    content: "",
  });
  const [pageHook, setPageHook] = usePagination();
  const { limit, page, total } = pageHook;
  const { title, subtitle, photo, content } = dataModal;
  const [loadingState, setLoadingState] = useState(true);
  const [loadingLoadMore, setLoadingLoadMore] = useState(false);

  const handleOpenModal = (data: any) => {
    const { image, title_id, title_en, content_id, content_en, created_at } =
      data;
    setDataModal({
      title: isId ? title_id : title_en,
      subtitle: moment(created_at).format("DD MMM YYYY"),
      photo: `${process.env.REACT_APP_URL}/images/${image}`,
      content: isId ? content_id : content_en,
    });
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

  const fetchKegiatan = async (type: string) => {
    try {
      if (type === "loadMore") setLoadingLoadMore(true);
      const res = await getContent(5, limit, page);
      setKegiatanState((prevState: any) => prevState.concat(res.data.rows));
      setPageHook({ ...pageHook, total: res.data.total });
      if (type === "loadMore") setLoadingLoadMore(false);
      if (type === "load") setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchKegiatan("load");
  }, []);

  useEffect(() => {
    if (!loadingState) {
      fetchKegiatan("loadMore");
    }
  }, [page]);

  return (
    <>
      <Typography
        variant="h4"
        color="primary"
        style={{ marginBottom: "2rem" }}
        gutterBottom
      >
        {isId ? "Kegiatan" : "Activities"}
      </Typography>
      <StyledWrapKegiatan>
        {loadingState ? (
          <div>
            <Skeleton
              variant="rect"
              height={200}
              style={{ marginBottom: 16 }}
            />
            <Skeleton variant="rect" height={42} />
          </div>
        ) : kegiatanState.length === 0 ? (
          <Typography color="textPrimary">
            {isId ? "Tidak ada data Kegiatan" : "No activities data"}
          </Typography>
        ) : (
          kegiatanState.map((r, i) => (
            <ItemKegiatan
              key={i}
              isId={isId}
              data={r}
              onClick={() => handleOpenModal(r)}
            />
          ))
        )}
      </StyledWrapKegiatan>
      {kegiatanState.length < total && (
        <div
          style={{
            marginTop: "1rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            disabled={loadingLoadMore}
            onClick={() => setPageHook({ ...pageHook, page: page + 1 })}
            style={{ fontWeight: 600 }}
          >
            {loadingLoadMore
              ? "Loading ..."
              : !isId
              ? "Load More"
              : "Tampilkan lebih Banyak"}
          </Button>
        </div>
      )}
      <Modal
        isOpen={openModal}
        onRequestClose={handleCloseModal}
        title={title}
        subtitle={subtitle}
        photo={photo}
        content={content}
        widthImg={600}
      />
    </>
  );
};

export default Kegiatan;
